<template>
  <div class="card h-100 businessresource-card text-lg-start">
    <a :href="businessResource.url" :aria-label="businessResource.name">
      <div class="image-wrap">
        <img :src="businessResource.imageUrl" :alt="businessResource.name" class="card-img-top"/>
      </div>
    </a>
    <div class="card-body d-flex flex-column">
      <div class="card-title businessresource-title h4">
        <a :href="businessResource.url" class="text-black" v-html="businessResource.name"></a>
      </div>
      <div v-if="businessResource.memberNames != ''" class="card-title businessresource-title h5">
        {{ businessResource.memberNames }}
      </div>
    </div>
    <div class="card-footer bg-transparent businessresource-buttons d-none d-lg-grid">
      <slot v-if="businessResource.assetType=='video'" name="businessresource-result-button" :businessResource="businessResource"></slot>

      <slot v-if="businessResource.assetType=='file' && businessResource.downloadUrl !=''" name="businessresource-file-download-button" :businessResource="businessResource"></slot>
      <slot v-if="businessResource.assetType=='file'" name="businessresource-file-preview-button" :businessResource="businessResource"></slot>
    </div>
  </div>
  
</template>

<script>
export default {
    props: ['businessResource'],
  computed: {
  },
  methods: {
  },
  mounted() {
  }
}
</script>
